import { ROUTES } from 'src/components/app/app-routes.constants';

export const getPath = (path: string) => {
  if (path.includes(ROUTES.employee)) {
    return ROUTES.employee;
  }
  if (path.includes(ROUTES.jobs)) {
    return ROUTES.jobs;
  }
  if (path.includes(ROUTES.vacancies)) {
    return ROUTES.vacancies;
  }

  return path;
};
